// extracted by mini-css-extract-plugin
export default {"Header__Section":"Header_Header__Section__v9UQb","Main__Title":"Header_Main__Title__LW0f+","Description":"Header_Description__MlLGP","Header__Image":"Header_Header__Image__F6aR4"};